import React from "react";
import "../css/NavbarDetail.css";

class NavbarDetail extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      isTop: true,
    };
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    document.addEventListener("scroll", () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop && this._isMounted) {
        this.onScroll(isTop);
        document
          .getElementById("navbarDetail")
          .classList.toggle("navbarScrooled");
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onScroll(isTop) {
    this.setState({ isTop });
  }

  myRef = React.createRef();

  render() {
    return (
      <nav
        className="navbar navbar-expand-lg navbar-light bg-transparant fixed-top"
        id="navbarDetail"
      >
        <a className="navbar-brand" href="./">
          {/*<img src={logo} className="img-fluid" alt="logo" />*/}IKAEMERCE
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto text-center">
            <li className="nav-item active">
              <a
                href=" https://api.whatsapp.com/send?phone=6285161016522"
                className="nav-link rounded rounded-pill"
              >
                {" "}
                CONTACT US{" "}
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

export default NavbarDetail;
